import "core-js/modules/es.array.includes.js";
import { renderSlot as _renderSlot, withModifiers as _withModifiers, createElementVNode as _createElementVNode, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mg-drop-menu-wrapper"
};
import { ref, reactive, computed, watch, onMounted, onUnmounted } from 'vue';
import { MgMenu } from '../menu';
export default {
  __name: 'mg-drop-menu',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    trigger: {
      type: String,
      default: 'hover',
      validator: val => ['hover', 'click'].includes(val)
    },
    transfer: {
      type: Boolean,
      default: true
    },
    // 下拉菜单子菜单弹出方向，默认右则
    direction: {
      type: String,
      default: 'right',
      validator: val => ['left', 'right'].includes(val)
    }
  },
  emits: ['itemClick', 'update:show'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const dropdownRef = ref();
    const menuAttrs = reactive({
      pos: {
        x: '0',
        y: '0'
      },
      autoHide: false,
      show: true
    });
    const props = __props;
    const emit = __emit;
    const showDropdown = ref(false);
    const mouseoutTimer = ref(0);
    const menuWrapperStyle = reactive({
      width: 'auto',
      height: 'auto'
    });
    watch(() => props.show, val => {
      showDropdown.value = val;
    }, {
      immediate: true
    });
    const showDropdownMenu = () => {
      showDropdown.value = true;
      emit('update:show', true);
    };
    const hideDropdownMenu = () => {
      showDropdown.value = false;
      emit('update:show', false);
    };
    const isShowDropdownMenu = computed(() => showDropdown.value);
    const handleDropdownMenuSize = ({
      width,
      height
    }) => {
      Object.assign(menuWrapperStyle, {
        width: `${width}px`,
        height: `${height}px`
      });
    };
    const handleClick = e => {
      if (props.trigger === 'click' && !isShowDropdownMenu.value) {
        showDropdownMenu(e);
      }
    };
    const handleMouseenter = e => {
      if (props.trigger === 'hover' && !isShowDropdownMenu.value) {
        showDropdownMenu(e);
      }
    };
    const handleMouseleave = e => {
      if (mouseoutTimer.value) {
        clearTimeout(mouseoutTimer.value);
      }
      mouseoutTimer.value = setTimeout(() => {
        hideDropdownMenu(e);
        mouseoutTimer.value = 0;
      }, 1500);
    };
    const handleMenuMouseenter = () => {
      if (mouseoutTimer.value) {
        clearTimeout(mouseoutTimer.value);
        mouseoutTimer.value = 0;
      }
    };
    const handleMenuMouseleave = e => {
      if (isShowDropdownMenu.value) {
        hideDropdownMenu(e);
      }
    };
    const handleMenuItemClick = ({
      item,
      $event
    }) => {
      emit('itemClick', {
        item,
        $event
      });
      hideDropdownMenu();
    };
    __expose({
      // isShowDropdown 是否显示下拉菜单
      'isShowDropdown'() {
        return isShowDropdownMenu.value;
      },
      // showDropdown 手动显示下拉菜单
      showDropdown: showDropdownMenu,
      // hideDropdown 手动隐藏下拉菜单
      hideDropdown: hideDropdownMenu
    });
    onMounted(() => {});
    onUnmounted(() => {
      if (mouseoutTimer.value) {
        clearTimeout(mouseoutTimer.value);
        mouseoutTimer.value = 0;
      }
    });
    return (_ctx, _cache) => {
      const _component_vxe_pulldown = _resolveComponent("vxe-pulldown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_vxe_pulldown, {
        trigger: "manual",
        modelValue: showDropdown.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => showDropdown.value = $event),
        transfer: __props.transfer,
        placement: "bottom",
        "destroy-on-close": ""
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          onClick: _withModifiers(handleClick, ["stop"]),
          onMouseenter: _withModifiers(handleMouseenter, ["stop"]),
          onMouseleave: _withModifiers(handleMouseleave, ["stop"])
        }, [_renderSlot(_ctx.$slots, "default")], 32)]),
        dropdown: _withCtx(() => [_createElementVNode("div", {
          ref_key: "dropdownRef",
          ref: dropdownRef,
          style: _normalizeStyle(menuWrapperStyle)
        }, [_createVNode(_unref(MgMenu), _mergeProps({
          items: __props.items,
          direction: __props.direction
        }, menuAttrs, {
          onMouseleave: handleMenuMouseleave,
          onMouseenter: handleMenuMouseenter,
          onItemClick: handleMenuItemClick,
          onMenuSize: handleDropdownMenuSize
        }), null, 16, ["items", "direction"])], 4)]),
        _: 3
      }, 8, ["modelValue", "transfer"])]);
    };
  }
};